import PropTypes from 'prop-types';
import * as React from "react";
import {translate} from "react-i18next";
import {connect, Dispatch} from "react-redux";
// components
import RecentDocuments from "./RecentDocuments";
import ViewContainer, {ICommonViewProps} from "../ViewContainer";

import ErrorBoundary from '../../utils/ErrorBoundary';
import {MenuDto, InitDto, VersionInfoDto} from '../../services/Client';
// import OpenWorkflowItem from './OpenWorkflowItem';
import GeneralActions from "../../redux/actions/GeneralActions";
import NotesAndNews from "./NotesAndNews";
import {compose} from 'redux';
import {IUserSettings} from 'src/data/IUserSettings';
import HATEOASClient from 'src/services/HATEOASClient';
import {
    selectBaseLinks,
    selectClient,
    selectUserSettings,
    selectVersionInfo
} from '../../redux/selectors';
import {IReduxState} from 'src/redux/IReduxState';
import MainTiles from '../../components/NavLink/MainTiles';
import {Button, Modal, ModalActions, ModalContent, ModalHeader} from 'semantic-ui-react';
import OpenSource from './OpenSource';

interface IMapStateToProps {
    userSettings: IUserSettings;
    baseLinks: MenuDto | undefined;
    client: HATEOASClient;
    versionInfo: VersionInfoDto | undefined;
}
interface IMapDispatchToProps {
    AddLoadingMessage: (loadingMsgInitData: string) => void;
    ReceiveBaseLinksAction: (baseLinks: MenuDto) => void;
    ReceiveInitDataAction: (initDto: InitDto) => void;
    RemoveLoadingMessage: (message: string) => void;
}
interface IStartViewProps extends ICommonViewProps, IMapStateToProps, IMapDispatchToProps {
    /** Optional property for previous location */
    from?: Location;
    history: any;
}
interface IStartViewState {isOpenSource: boolean;}

// TODO refactor this component and remove async/await implementation
class StartView extends React.Component<IStartViewProps, IStartViewState> {
    constructor(props: IStartViewProps) {
        super(props);
        this.state = {
            isOpenSource: false
        };
    }

    static contextTypes = {
        router: PropTypes.object
    };

    render() {
        if (this.props.userSettings) {
            let lng = this.props.userSettings.language;
            if (this.props.i18n.language !== lng)
                this.props.i18n.changeLanguage(lng);
        }

        let versionLabel: string | null = null;
        if (this.props.versionInfo) {
            const versionInfo = this.props.versionInfo as any;
            const versions = versionInfo.componentVersions || versionInfo;
            versionLabel = Object.keys(versions).map(key => `${key}: ${versions[key]}`).join(' / ');
        }

        return (
            <ViewContainer className='display--flex porsche-background'>
                <div className='start-view-content-container'>
                    <div className='start-view-grid'>
                        <MainTiles />
                    </div>
                    <div className="start-view-board-tile-container">
                        <div className='start-view-board-tile'>
                            <ErrorBoundary >
                                <RecentDocuments />
                            </ErrorBoundary>
                        </div>
                        <div className='start-view-board-tile'>
                            <ErrorBoundary >
                                <NotesAndNews history={this.props.history} />
                            </ErrorBoundary>
                        </div>
                    </div>
                    {/* <p> {versionLabel}</p> */}
                    {/* <p>1.0.0-1.0.0</p> */}
                    <div className='start-view-version'>
                        <p  data-cy="version">version: {versionLabel}</p>
                        <Modal
                            size='large'
                            dimmer='blurring'
                            closeIcon={true}
                            onClose={() => this.setState({isOpenSource: false})}
                            open={this.state.isOpenSource}
                            trigger={<Button className='open-source' onClick={() => this.setState({isOpenSource: true})}>Open Source Software Notice</Button>}
                        >
                            <ModalHeader>Open Source Software Notice</ModalHeader>
                            <ModalContent scrolling={true}>
                                <OpenSource />
                            </ModalContent>
                            <ModalActions>
                                <Button color='black' onClick={() => this.setState({isOpenSource: false})}>
                                    Close
                                </Button>
                            </ModalActions>
                        </Modal>
                    </div>
                </div>
            </ViewContainer>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    userSettings: selectUserSettings(state),
    client: selectClient(state),
    versionInfo: selectVersionInfo(state),
    baseLinks: selectBaseLinks(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    AddLoadingMessage: (loadingMsgInitData) => dispatch(GeneralActions.AddLoadingMessage(loadingMsgInitData)),
    ReceiveBaseLinksAction: (baseLinks) => dispatch(GeneralActions.ReceiveBaseLinksAction(baseLinks)),
    ReceiveInitDataAction: (initDto) => dispatch(GeneralActions.ReceiveInitDataAction(initDto)),
    RemoveLoadingMessage: (message) => dispatch(GeneralActions.RemoveLoadingMessage(message))
});

export default compose(
    translate(["START_VIEW", "SIDEBAR"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(StartView);



// WEBPACK FOOTER //
// ./src/views/MainView/StartView.tsx